var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	2916: {
		fallback: () => (__webpack_require__.e(797).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	1246: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	602: {
		fallback: () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(5072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	1783: {
		fallback: () => (__webpack_require__.e(343).then(() => (() => (__webpack_require__(3962))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "~7.8.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	5162: {
		fallback: () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.3.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	4428: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.3.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	5598: {
		fallback: () => (__webpack_require__.e(681).then(() => (() => (__webpack_require__(6443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.3.12",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	7660: {
		fallback: () => (__webpack_require__.e(576).then(() => (() => (__webpack_require__(6576))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.14",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@itero/auth-angular",

	},
	7574: {
		fallback: () => (__webpack_require__.e(681).then(() => (() => (__webpack_require__(6443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	367: {
		fallback: () => (__webpack_require__.e(221).then(() => (() => (__webpack_require__(4602))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.0.0-dev.185.51",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@itero/assets-bff-sdk",

	},
	4864: {
		fallback: () => (__webpack_require__.e(797).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	6810: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.0 || ^18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	5601: {
		fallback: () => (__webpack_require__.e(581).then(() => (() => (__webpack_require__(3962))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.5.3 || ^7.4.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	6446: {
		fallback: () => (__webpack_require__.e(797).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	4923: {
		fallback: () => (__webpack_require__.e(797).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	1000: {
		fallback: () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(5072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	8594: {
		fallback: () => (__webpack_require__.e(343).then(() => (() => (__webpack_require__(3962))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=7.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	7508: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=17.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	7006: {
		fallback: () => (__webpack_require__.e(797).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=15.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	7652: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=15.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	2561: {
		fallback: () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	1655: {
		fallback: () => (__webpack_require__.e(824).then(() => (() => (__webpack_require__(6443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	6253: {
		fallback: () => (__webpack_require__.e(724).then(() => (() => (__webpack_require__(3962))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.6.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	8309: {
		fallback: () => (__webpack_require__.e(940).then(() => (() => (__webpack_require__(8559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"20": [
		367,
		602,
		1000,
		1246,
		1783,
		2916,
		4428,
		4864,
		4923,
		5162,
		5598,
		5601,
		6446,
		6810,
		7006,
		7508,
		7574,
		7652,
		7660,
		8594
	],
	"72": [
		4428,
		5162,
		5598,
		5601
	],
	"165": [
		2916,
		1246,
		602,
		1783,
		5162,
		4428,
		5598,
		7660,
		7574,
		367,
		4864,
		6810,
		5601,
		6446,
		4923,
		1000,
		8594,
		7508
	],
	"195": [
		1655,
		6253,
		8309
	],
	"286": [
		2916,
		1783,
		1246,
		7660,
		7574,
		367,
		602,
		4923,
		5601,
		5162,
		4428,
		4864,
		6810,
		5598,
		7006,
		7652,
		6446,
		1000,
		8594,
		7508
	],
	"443": [
		2561,
		5162,
		5601
	],
	"559": [
		5601
	],
	"576": [
		1655,
		6253,
		8309
	],
	"681": [
		2561
	],
	"705": [
		2916,
		5162,
		4428,
		5598,
		1246,
		602,
		1783,
		7660,
		7574,
		367,
		4864,
		6810,
		5601,
		6446,
		4923,
		1000,
		8594,
		7508,
		7006,
		7652
	],
	"824": [
		2561,
		5162,
		5601
	],
	"935": [
		5162
	],
	"940": [
		5601
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}